import { render } from "./fact.vue?vue&type=template&id=6a6bb75c&scoped=true"
import script from "./fact.vue?vue&type=script&lang=js"
export * from "./fact.vue?vue&type=script&lang=js"

import "./fact.vue?vue&type=style&index=0&id=6a6bb75c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a6bb75c"]])

export default __exports__